"use client";
import { useEffect, useState } from "react";

/**
 * Detects pure-touch devices via matchMedia. Read once on mount.
 * Do NOT call matchMedia inside event handlers.
 * SSR-safe: returns false initially, real value set after hydration.
 */
export function useTouchDevice(): boolean {
  const [isTouch, setIsTouch] = useState(false);
  useEffect(() => {
    setIsTouch(window.matchMedia("(hover: none) and (pointer: coarse)").matches);
  }, []);
  return isTouch;
}
